import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import { Organization, User } from 'lib-shared-types-api';
import { Component } from 'react';

import { TopbarButton } from '../../topbar/components/topbarButton';

import '../styles/beamer-button.less';

type PropsT = {
  profile: User;
  organization: Organization;
  className?: string;
};

class BeamerButton extends Component<PropsT> {
  constructor(props: PropsT) {
    super(props);
  }

  componentDidMount() {
    const { id, is_admin, email, name } = this.props.profile;
    const { created_at } = this.props.organization;
    const nameArr = name ? name.split(/\s+/) : [];
    window.beamer_config.user_id = id;
    window.beamer_config.filter = is_admin ? 'admin' : 'agent';
    window.beamer_config.user_email = email;
    window.beamer_config.organization_created_at = created_at;
    window.beamer_config.user_firstname = nameArr.shift();
    window.beamer_config.user_lastname = nameArr.join(' ');
    if (window.Beamer) {
      window.Beamer.init();
    } else {
      window.beamer_config.callback = () => {
        window.Beamer.init();
      };
    }
  }

  render() {
    const { className } = this.props;
    const rootClass = classnames({}, className);

    return (
      <TopbarButton
        id="topbar-beamer"
        tooltip="What's new"
        className={rootClass + ' pull-right'}
        onClick={() => {
          window.Beamer.show();
          ampli.topbarBeamerOpened();
        }}
        icon="gift"
      />
    );
  }
}

export default BeamerButton;
